import { gql } from '@apollo/client';

/**
 * 802.1X Phase A — push, remove, validate, query operations.
 * See spec: docs/specs/19-optiedge-mdm/802.1x/01-802.1x-spec.md §4.
 *
 * Operation names are pinned by Apollo `refetchQueries` callers and the
 * cross-system contract tests in
 * `optisigns-open-api/test/cross-system/enterprise-wifi-*.spec.ts`.
 */

export const PUSH_ENTERPRISE_WIFI_PROFILE = gql`
  mutation PushEnterpriseWifiProfile($wifiInfoId: ID!, $deviceIds: [ID!]!) {
    pushEnterpriseWifiProfile(wifiInfoId: $wifiInfoId, deviceIds: $deviceIds) {
      batchId
      dispatched
      skipped {
        deviceId
        reason
      }
    }
  }
`;

export const REMOVE_ENTERPRISE_WIFI_PROFILE = gql`
  mutation RemoveEnterpriseWifiProfile($wifiInfoId: ID!, $deviceIds: [ID!]!) {
    removeEnterpriseWifiProfile(wifiInfoId: $wifiInfoId, deviceIds: $deviceIds) {
      batchId
      dispatched
      skipped {
        deviceId
        reason
      }
    }
  }
`;

export const VALIDATE_ENTERPRISE_WIFI_PROFILE = gql`
  mutation ValidateEnterpriseWifiProfile($input: WifiInfoInput!) {
    validateEnterpriseWifiProfile(input: $input) {
      ok
      errors {
        field
        code
        message
      }
    }
  }
`;

export const ENTERPRISE_WIFI_COMPATIBILITY = gql`
  query EnterpriseWifiCompatibility($deviceIds: [ID!]!) {
    enterpriseWifiCompatibility(deviceIds: $deviceIds) {
      deviceId
      supported
      reason
      capabilities {
        tls13
        wpa3
        wpa3_192bit
        strongbox
      }
    }
  }
`;

// Mutation result + variable types — feature consumers import these
export interface EnterpriseWifiPushPayload {
  batchId: string;
  dispatched: number;
  skipped: Array<{ deviceId: string; reason: string }>;
}

export interface PushEnterpriseWifiProfileResult {
  pushEnterpriseWifiProfile: EnterpriseWifiPushPayload;
}

export interface RemoveEnterpriseWifiProfileResult {
  removeEnterpriseWifiProfile: EnterpriseWifiPushPayload;
}

export interface PushEnterpriseWifiProfileVariables {
  wifiInfoId: string;
  deviceIds: string[];
}

export interface ValidateEnterpriseWifiProfileResult {
  validateEnterpriseWifiProfile: {
    ok: boolean;
    errors: Array<{
      field: string;
      code: string;
      message: string;
    }>;
  };
}

export interface EnterpriseWifiCompatibilityResult {
  enterpriseWifiCompatibility: Array<{
    deviceId: string;
    supported: boolean;
    reason: string | null;
    capabilities: {
      tls13: boolean;
      wpa3: boolean;
      wpa3_192bit: boolean;
      strongbox: boolean;
    };
  }>;
}

export interface EnterpriseWifiCompatibilityVariables {
  deviceIds: string[];
}
